"use client";

import { useEffect, useState } from "react";
import { fetchCourseRequestsCount } from "../lib/courseLearnerApi";

/**
 * Subscriber ("مشترك") count. Renders the server value instantly (SSR/ISR), then
 * refreshes to the live count on mount so it isn't stuck behind the page's hourly
 * ISR cache. Falls back to the initial value if the live fetch fails.
 *
 * @param {{ courseId: string | number, initial?: number | null }} props
 */
export default function CourseSubscriberCount({ courseId, initial = null }) {
    const [count, setCount] = useState(typeof initial === "number" ? initial : null);

    useEffect(() => {
        let alive = true;
        fetchCourseRequestsCount(courseId).then((n) => {
            if (alive && typeof n === "number") setCount(n);
        });
        return () => {
            alive = false;
        };
    }, [courseId]);

    return (
        <span className="me-2">
            <i className="bi bi-people"></i>{" "}
            {count !== null ? `${count.toLocaleString("ar-EG")} مشترك` : "—"}
        </span>
    );
}
